module.exports = __webpack_public_path__ + "static/img/theme_07.4a4b7b27.png";